import { useHead } from '@unhead/react';
import { Layout } from 'antd';
import type { User } from 'better-auth';
import type { PropsWithChildren } from 'react';
import { LanguageSelector } from 'ui/language-selector';
import { Logo } from 'ui/logo';
import { PageTitle } from 'ui/page-title';
import { UserMenu } from 'ui/user-menu';

export const Page = ({
  title,
  user,
  children,
}: PropsWithChildren<{ title: string; user?: User | null }>) => {
  useHead({ title });

  return (
    <Layout className="flex h-dvh flex-col">
      <Layout.Header className="flex h-10 items-center-safe justify-between bg-gray-50 px-5 drop-shadow-lg">
        <Logo />
        <PageTitle title={title} />
        <div className="flex">{user ? <UserMenu /> : <LanguageSelector />}</div>
      </Layout.Header>
      <Layout.Content className="bg-light-blue flex w-full flex-1 overflow-y-auto">
        {children}
      </Layout.Content>
    </Layout>
  );
};
